import { render } from "./QuickLinks.vue?vue&type=template&id=00bbd520&scoped=true"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"

import "./QuickLinks.vue?vue&type=style&index=0&id=00bbd520&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bbd520"]])

export default __exports__